import { Controller } from "@hotwired/stimulus";

/**
 * Nav Health Controller
 * 
 * Manages the navigation health indicators in the admin interface.
 * Periodically fetches and updates job counts and SageMaker queue statistics.
 * 
 * Features:
 * - Fetches job counts from admin endpoint every 30 seconds
 * - Fetches SageMaker queue and worker statistics
 * - Updates navigation health indicators with current counts
 * - Shows error indicators (!) when requests fail
 * - Automatically refreshes on connect and stops on disconnect
 * 
 * Usage: Add data-controller="nav-health" to admin navigation elements that display health indicators
 */
export default class extends Controller {
  static targets = ["jobs", "queue"];

  connect() {
    this.refresh();
    this.interval = setInterval(() => this.refresh(), 30000);
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval);
  }

  refresh() {
    // Jobs count (routes: admin/jobs#count => /admin/jobs/count)
    fetch('/admin/jobs/count')
      .then(response => response.json())
      .then(data => {
        const jobsEl = document.getElementById('nav-health-jobs');
        if (jobsEl) jobsEl.textContent = `${data.jobs || 0}J`;
      })
      .catch(() => {
        const jobsEl = document.getElementById('nav-health-jobs');
        if (jobsEl) jobsEl.textContent = '!';
      });

    // SageMaker queue stats
    fetch('/admin/sage_maker/queue_stats')
      .then(response => response.json())
      .then(data => {
        const queueEl = document.getElementById('nav-health-queue');
        const workersEl = document.getElementById('nav-health-workers');
        if (queueEl) queueEl.textContent = `${data.queued_jobs || 0}Q`;
        if (workersEl) workersEl.textContent = `${data.active_workers || 0}W`;
      })
      .catch(() => {
        const queueEl = document.getElementById('nav-health-queue');
        const workersEl = document.getElementById('nav-health-workers');
        if (queueEl) queueEl.textContent = '!';
        if (workersEl) workersEl.textContent = '!';
      });
  }
} 